module.exports = __webpack_public_path__ + "static/img/about.3e10bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about.jpg
// module id = a2q9
// module chunks = 1